<template>
  <material-card icon="mdi-clipboard-text" inline title="Fee Types">
    <v-card-text class="pt-0 pr-1"
      :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
      <v-btn absolute right top elevation="1" v-on:click="addFeeType()" :class="{ 'mt-2': $vuetify.breakpoint.xs }"
        color="accent">
        <v-icon left>mdi-plus</v-icon>
        Add Fee Type
      </v-btn>
    </v-card-text>
    <v-card flat class="px-2">
      <v-data-table :headers="headers" :items="resultArray" :footer-props="{
        'items-per-page-options': [5, 10, 20, 40]
      }" :items-per-page="10">
        <template v-slot:item.name="{ item }">
          <span class="text-capitalize">{{ item.name }} </span>
        </template>
        <template v-slot:item.InvoiceFeeName="{ item }">
          <span class="text-capitalize">{{ item.InvoiceFeeName }} </span>
        </template>
        <template v-slot:item.isRoyalty="{ item }">
          <span class="text-capitalize">{{ item.isRoyalty }} </span>
        </template>
        <template v-slot:item.isActive="{ item }">
          {{ item.isActive ? 'Active' : 'Inactive' }}
        </template>
        <template v-slot:item.isApproved="{ item }">
          {{ item.isApproved ? 'True' : 'False' }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn class="px-2 ml-1 ma-1" outlined color="success" min-width="0" small
            v-if="modules.FeeTypeApproval && !item.isActive" @click.prevent="approveFeeType(item.id)"
            title="Approve">Approve</v-btn>
          <v-btn class="px-2 ml-1 ma-1" color="error" min-width="0" small v-if="item.isActive"
            @click.prevent="deactivateFeeType(item.id)" title="Delete">
            <v-icon small> mdi-delete</v-icon>
          </v-btn>
          <v-btn class="px-2 ml-1 ma-1" color="info" min-width="0" small @click.prevent="activateFeeType(item.id)"
            v-if="!item.isActive" title="Restore">
            <v-icon small> mdi-restore</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </material-card>
</template>
<script>
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import Utils from '@/utils'
export default {
  components: { MaterialCard },
  data () {
    return {
      headers: [
        { text: 'Fee Type Name', value: 'name', sortable: true },
        { text: 'Invoice Fee Name', value: 'InvoiceFeeName', sortable: true },
        { text: 'Is Royalty Applicable', value: 'isRoyalty', sortable: true },
        { text: 'Status', value: 'isActive', sortable: true },
        { text: 'Is Approved', value: 'isApproved', sortable: true },
        { text: 'Action', value: 'actions', sortable: false }
      ],
      resultArray: [],
      isLoading: false,
      isData: false,
      modules: {
        FeeTypeApproval: this.checkModuleAccess('FeeTypeApproval')
      }
    }
  },
  created () {
    this.getDetails()
  },
  methods: {
    addFeeType: async function () {
      this.$router.push({ name: 'createFeeTypes' })
      this.getDetails()
    },
    getDetails: async function () {
      try {
        this.isLoading = true
        const responce = await http.get(`${constants.API_URL}/api/get-all-fee-type`)
        let Data = responce.data
        this.resultArray = Data.rows
        console.log('this.resultArray71::::', this.resultArray)
        if (this.resultArray.isActive === true) {
          this.isData = true
        }
        this.isLoading = false
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.isLoading = false
        console.log('error in fetching Details : ', errorMessage)
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    deactivateFeeType: async function (id) {
      let ref = this
      this.$dialog.warning({
        title: 'Deactivate Fee Type',
        text: 'Do you really want to <b>deactivate</b> this record?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'red',
            text: 'Yes',
            handle: async () => {
              try {
                ref.isLoading = true
                await http.put(`${constants.API_URL}/api/deactivate-fee-type/${id}`)
                ref.isLoading = false
                await ref.getDetails()

                return ref.$dialog.info({
                  title: 'Success',
                  text: 'Deactivated Fee Type Successfully'
                })
              } catch (e) {
                ref.isLoading = false
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                return ref.$dialog.error({
                  title: 'Error',
                  text: errorMessage
                })
              }
            }
          }
        }
      })
    },
    activateFeeType: async function (id) {
      let ref = this
      this.$dialog.warning({
        title: 'activate Fee Type',
        text: 'Do you really want to <b>activate</b> this record?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'red',
            text: 'Yes',
            handle: async () => {
              try {
                ref.isLoading = true
                await http.put(`${constants.API_URL}/api/activate-fee-type/${id}`)
                ref.isLoading = false
                await ref.getDetails()

                return ref.$dialog.info({
                  title: 'Success',
                  text: 'Activated Fee Type Successfully'
                })
              } catch (e) {
                ref.isLoading = false
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                return ref.$dialog.error({
                  title: 'Error',
                  text: errorMessage
                })
              }
            }
          }
        }
      })
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    approveFeeType: async function (id) {
      let ref = this
      this.$dialog.warning({
        title: 'Approve Fee Type',
        text: 'Do you really want to <b>Approve</b> this fee type?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'red',
            text: 'Yes',
            handle: async () => {
              try {
                ref.isLoading = true
                await http.put(`${constants.API_URL}/api/approved-fee-type/${id}`)
                ref.isLoading = false
                await ref.getDetails()

                return ref.$dialog.info({
                  title: 'Success',
                  text: 'Fee Type Successfully Approved!!'
                })
              } catch (e) {
                ref.isLoading = false
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                return ref.$dialog.error({
                  title: 'Error',
                  text: errorMessage
                })
              }
            }
          }
        }
      })
    }
  }
}
</script>
